module.exports = __webpack_public_path__ + "media/images/icons/heart-pink-6c9b313bd5eb7727d6ee5d195b185db7.svg";